exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "p[data-v-53a7d792]{padding:0}thead th[data-v-53a7d792]{border:1px solid #ececec}.table td[data-v-53a7d792],.table th[data-v-53a7d792]{text-align:center;padding:5px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-53a7d792","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/pages/user_schedule.vue
// module id = 180
// module chunks = 0